import type * as ngCore from '@angular/core'

import * as components from '../components'

import { TOKENS } from './tokens'

/**
 * Maps every token in {@link TOKENS} to its real component.
 *
 * `satisfies Record<keyof typeof TOKENS, unknown>` makes TypeScript error
 * if a token exists in {@link TOKENS} but is missing here.
 */
const COMPONENT_MAP = {
  referenceCellComponent:
    components.platform.content.display.value.readonly.reference.Component,
} satisfies Record<keyof typeof TOKENS, unknown>

/**
 * Wires every {@link TOKENS component-bridge token} to its real component.
 *
 * Called once from {@link ../bootstrap.ts bootstrap}.
 */
export function provide(): ngCore.Provider[] {
  return Object.entries(COMPONENT_MAP).map(([key, value]) => ({
    provide: TOKENS[key as keyof typeof TOKENS],
    useValue: value,
  }))
}
